import {createAction, createReducer} from '@reduxjs/toolkit';

import {PayPalErrorType, PayPalType} from 'types/paypalType';

export const initialState: PayPalType = {
    error: [],
    isLoading: true,
    params: {},
};

export const methodPaypalSetError = createAction<PayPalErrorType>(
    'CHECKOUT@METHOD_PAYPAL@SET_ERROR',
);

export const methodPaypalSetParams = createAction<{}>('CHECKOUT@METHOD_PAYPAL@SET_PARAMS');

export const methodPaypalSetLoading = createAction<boolean>('CHECKOUT@METHOD_PAYPAL@SET_LOADING');

/**
 * paypal reducer
 *
 * @return {PayPalType} - paypal state
 */
export const paypal = createReducer(initialState, builder =>
    builder
        .addCase(methodPaypalSetError, (state, action) => ({
            ...state,
            error: action.payload,
        }))
        .addCase(methodPaypalSetLoading, (state, action) => ({
            ...state,
            isLoading: action.payload,
        }))
        .addCase(methodPaypalSetParams, (state, action) => ({
            ...state,
            params: action.payload,
        })),
);
